module.exports = __webpack_public_path__ + "static/bg-white-1-c3002f2d14ea67c10847e559298743c0.jpg";